import { useState } from "react"

// https://stackoverflow.com/questions/70612769/how-do-i-recognize-swipe-events-in-react
const useSwipe = (input) => {
    const [touchStart, setTouchStart] = useState(0)
    const [touchEnd, setTouchEnd] = useState(0)

    const minSwipeDistance = 100

    const onTouchStart = (e) => {
        let node = e.target
        while (node) {
            if (node.hasAttribute?.("data-disable-swipe")) {
                return
            }
            node = node.parentElement
        }

        setTouchEnd(0)
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => {
        let node = e.target
        while (node) {
            if (node.hasAttribute?.("data-disable-swipe")) {
                return
            }
            node = node.parentElement
        }
        setTouchEnd(e.targetTouches[0].clientX)
    }

    const onTouchEnd = (e) => {
        let node = e.target
        while (node) {
            if (node.hasAttribute?.("data-disable-swipe")) {
                return
            }
            node = node.parentElement
        }
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe) {
            input.onSwipedLeft()
        }
        if (isRightSwipe) {
            input.onSwipedRight()
        }
    }

    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    }
}

export default useSwipe
